export default "__VITE_ASSET__b7866dfa__"